import axios from "axios";

import type { ShiftsResponse } from "@/types/shift.types";
import type { ApiError } from "@/types/workSessions.type";

import { api } from "./api";

interface GetShiftsParams {
  // Format YYYY-MM-DD ou ISO 8601
  from: string;
  to: string;
}

/**
 * Récupère les créneaux de la semaine courante pour la pointeuse.
 * Le backend filtre auto par companyId via le token pointeuse.
 */
export const getShifts = async (
  params: GetShiftsParams
): Promise<ShiftsResponse> => {
  try {
    const response = await api.get<ShiftsResponse>("/shifts/pointeuse", {
      params,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const apiError = error.response?.data as ApiError;
      throw new Error(
        apiError?.message || "Erreur lors de la récupération du planning"
      );
    }
    throw new Error("Erreur lors de la récupération du planning");
  }
};
